export const companyProfile = {
    addFavoriteCompny: 'お気に入りに登録',
    removeFavoriteCompny: 'お気に入りから外す',

    fileDownloadError: 'ダウンロードに失敗しました。サポートチームにお問い合わせください。',

    companyTableColumnTheme: 'テーマ',
    companyTableColumnCompany: 'テーマとの親和性が高い企業',
    companyTableColumnRanking: '順位',
    companyTableColumnAffinity: '企業の知的財産との親和性',
    companyTableColumnAmount: 'マイノリティ出資額[百万円]',

    ipcName: '技術区分',
    patentcount: '特許出願件数',

    companyBodyDescription: `選択した企業のIP（知的財産）情報を表示しています。\n財務状況や保有技術を踏まえてアライアンス先や投資先の候補になる場合は、お気に入りに登録することができます。`,

    companyRadioTable: '企業と親和性があるテーマ',
    companyRadioTableLink: '詳しく見る',
    companyRadioTableDescription: '各テーマごとに企業が保有している特許の割合が高いテーマを確認できます。',
    companyTips: 'テーマを選択すると、左の出願数推移に反映されます',
    companyRadioTablecoulmn1: '順位',
    companyRadioTablecoulmn2: 'テーマ名',

    companyBodyFinanceTitle: '企業情報'
}
